export const segment_identify = (user_id, name, email, cellphone, created_at) => {
  const data = {
    name: name,
    phone: cellphone,
    created_at: created_at,
    id: user_id,
    email,
  };
  if ((window as any).analytics) {
    (window as any).analytics.identify(user_id, data);
  }
};

export const segment_track = (event, props) => {
  const analytics = (window as any).analytics;
  analytics.track(event, props);
};

export const segment_page = () => {
  const analytics = (window as any).analytics;
  if (analytics) {
    analytics.page();
  }
};

export const parseSpecialCharacters = (str) => {
  const numberPattern = /\d+/g;
  return str.match(numberPattern).join("");
};
